var render = function render(){var _vm=this,_c=_vm._self._c;return _c('blockquote',[_c('p',[_vm._v(_vm._s(_vm.fundingSource.name))]),_vm._v(" "),_c('p',[_vm._v("xxxx-xxxx-xxxx-"+_vm._s(_vm.fundingSource.lastFour))])])
}
var staticRenderFns = []

export { render, staticRenderFns }